export default function TimerBar({ section }) {
  return (
    <div className="h-[50px] bg-white border-b flex justify-between items-center px-6">
      <span className="font-semibold">{section} Section</span>
      <span className="font-mono text-red-600">⏱ 30:00</span>
    </div>
  );
}
